// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import flipPassiveRepeaterAntennas from './flipPassiveRepeaterAntennas'

/**
 * Takes the Path Details passive repeater values, reverses them and updates internal values to properly track segment end ids.
 * @param {Array} passiveRepeaters
 * @returns {Array} flippedPassiveRepeaters
 */
const flipPassiveRepeaters = passiveRepeaters => (
  // create a copy of the passiveRepeaters
  [...passiveRepeaters]
    // reverse it
    .reverse()
    // then loop over it and modify inner values which allow us to convert redux-form data into segments>segment_ends for the API.
    .map(passiveRepeater => {
      const { backToBack } = passiveRepeater
      const segmentEndId = passiveRepeater.site.secondSegmentEndId
      const secondSegmentEndId = passiveRepeater.site.segmentEndId

      const site = {
        ...passiveRepeater.site,
        segmentEndId,
        secondSegmentEndId,
      }

      const antennas = flipPassiveRepeaterAntennas(passiveRepeater)

      return {
        antennas,
        backToBack,
        site,
      }
    })
)

export default flipPassiveRepeaters
